import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(res.data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data } });
      } catch (e) {
        const denied = e?.response?.status === 403;
        setError(denied
          ? (e?.response?.data?.detail || "Access restricted — your account isn't authorized. Contact the admin.")
          : "Authentication failed. Please try again.");
        setTimeout(() => navigate("/", { replace: true }), denied ? 4000 : 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#050505] gap-6">
      <div className="relative w-24 h-24">
        <div className="absolute inset-0 rounded-full border-2 border-[#16C784]/30 pulse-ring" />
        <div className="absolute inset-2 rounded-full border-t-2 border-r-2 border-[#16C784] spin-slow" />
        <div className="absolute inset-0 flex items-center justify-center font-mono text-[#A3E635] text-[10px] tracking-[0.3em]">
          AUTH
        </div>
      </div>
      <p className="font-rajdhani uppercase tracking-[0.3em] text-sm text-[#A0A0AB]">
        {error || "Establishing secure link"}
      </p>
    </div>
  );
};

export default AuthCallback;
